import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { SearchableDropdown } from '../../component/SearchableDropdown';
import { TextInput } from '../../component/TextInput';
import { Option } from '../../pages/types';

export function FreeProductSection({
  title = 'Free promotional product(s)',
  eligibleCountrySelected,
  options,
  selectedOption,
  onChangeOption,
  quantity,
  setQuantity,
}: {
  title?: string;
  eligibleCountrySelected: boolean;
  options: Option[];
  selectedOption: Option | null;
  onChangeOption: (o: Option | null) => void;
  quantity: string;
  setQuantity: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <div className="w-full mb-2">
        <h2>{title}</h2>
        <div className="flex justify-between space-x-4">
          <div className="w-3/4">
            <SearchableDropdown
              placeholder={
                !eligibleCountrySelected
                  ? 'Select eligible country first'
                  : 'Select free product(s)'
              }
              options={options}
              value={selectedOption ?? null}
              onChange={(newSelection: any) => onChangeOption(newSelection ?? null)}
              isDisabled={!eligibleCountrySelected}
            />
          </div>
          <div className="w-1/4">
            <TextInput placeholder="None" value={quantity} setTextChange={setQuantity} />
          </div>
        </div>
      </div>
    </PromotionSectionCard>
  );
}
